import styled from 'styled-components'

export const CurrencyDiv = styled.div`
  display: inline;
  font-size: 1.25rem;
  vertical-align: super;
`
